module.exports = {
  "name": "bg_BG",
  "day": {
    "abbrev": [
      "нд",
      "пн",
      "вт",
      "ср",
      "чт",
      "пт",
      "сб"
    ],
    "full": [
      "неделя",
      "понеделник",
      "вторник",
      "сряда",
      "четвъртък",
      "петък",
      "събота"
    ]
  },
  "month": {
    "abbrev": [
      "яну",
      "фев",
      "мар",
      "апр",
      "май",
      "юни",
      "юли",
      "авг",
      "сеп",
      "окт",
      "ное",
      "дек"
    ],
    "full": [
      "януари",
      "февруари",
      "март",
      "април",
      "май",
      "юни",
      "юли",
      "август",
      "септември",
      "октомври",
      "ноември",
      "декември"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%e.%m.%Y",
  "time24": "%k,%M,%S",
  "dateTime": "%x (%a) %X %Z",
  "time12": "%l,%M,%S",
  "full": "%a %b %e %H:%M:%S %Z %Y"
}
